import _ from 'lodash'
import * as actionTypes from './actionTypes'
import { getAxios } from '../../lib/projectAxios'
import uuid from 'uuid/v4'
import { fromJS, List, Map } from 'immutable'

const axios = getAxios()

export const openPrivateModal = (pageParams) => async (dispatch, getState) => {
  const recursiveProcessGet = async (attemp) => {
    if (attemp >= 3) {
      return {
        status: 200,
        data: {
          status: false,
        },
      }
    }
    try {
      let result = await axios.post('/webprojects/process/modal')
      return result
    } catch (err) {
      console.log('err >>> ', err)
      await new Promise((resolve) => {
        setTimeout(resolve, 2 * 1000)
      })

      return recursiveProcessGet(attemp + 1)
    }
  }

  let { status, data } = await recursiveProcessGet(0)

  if (data.status) {
    let localParams = pageParams.getIn(['params'], List())
    _.each(data.params, function (val, key) {
      localParams = localParams.push(`${key}=${val}`)
    })
    pageParams = pageParams.setIn(['params'], localParams)
  }

  let state = getState()

  state = state
    .setIn(['widgets', 'RedirectModal', 'needShow'], true)
    .setIn(['widgets', 'RedirectModal', 'params'], pageParams)

  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: state,
    },
  })
}
